import { render, staticRenderFns } from "./myPromotion.vue?vue&type=template&id=d3106bac&"
import script from "./myPromotion.vue?vue&type=script&lang=js&"
export * from "./myPromotion.vue?vue&type=script&lang=js&"
import style0 from "./myPromotion.vue?vue&type=style&index=0&id=d3106bac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports